<template>
  <div
    :class="{
      'drag-active': drag,
      uploading: uploading,
      'upload-success': uploadSuccess
    }"
    class="text-center"
  >
    <div @click="launchFilePicker()">
      <div
        class="image-picker-placeholder-container pointer"
        @dragenter="enter"
        @dragleave="leave"
        @mouseover="enter"
        @mouseleave="leave"
        @drop="dropHandler"
        @dragover="dragOverHandler"
      >
        <img
          v-if="
            uploading == false && uploaded == false && uploadSuccess == false
          "
          :src="
            drag == false
              ? require('@/assets/images/drop-image.png')
              : require('@/assets/images/on-drop-image.png')
          "
          class="drop-image"
        />
        <div
          class="d-flex justify-center align-center lighten-3 mb-3 image-placeholder"
        >
          <div v-if="uploading">
            <div class="progress-bar">
              <div ref="bar" class="bar" style="height:20px;"></div>
            </div>
            <h4>We're uploading your images...</h4>
          </div>
          <slot
            name="activator"
            v-if="!uploading && !uploadSuccess && uploaded"
          >
          </slot>
          <div v-if="uploadSuccess">
            <img
              v-if="uploadSuccess"
              :src="require('@/assets/images/circle-tick.png')"
              alt=""
              srcset=""
            />
            <h4>
              Your upload is <span class="primary--text">successfull!</span>
            </h4>
          </div>
        </div>
        <v-btn
          v-if="uploaded"
          @click.stop="$emit('delete-item')"
          color="dark-grey"
          class="delete-btn white--text"
          >DELETE IMAGE</v-btn
        >
      </div>
    </div>
    <input
      ref="file"
      id="file"
      type="file"
      @change="onFileChange"
      style="display:none"
    />
    <v-dialog v-model="showCropper" width="500">
      <v-card>
        <v-card-title>Crop Image</v-card-title>
        <v-card-text>
          <cropper
            class="cropper"
            :src="img"
            :stencil-props="{
              aspectRatio: 12 / 12
            }"
            @change="change"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="doneCropping">
            Done!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
  props: {
    uploaded: {
      default: false,
      type: Boolean
    }
  },
  components: {
    Cropper
  },
  data() {
    return {
      width: 0,
      showCropper: false,
      interval: null,
      drag: false,
      uploading: false,
      uploadSuccess: false,
      progress: 0,
      asd: "asd",
      img:
        "https://images.unsplash.com/photo-1600984575359-310ae7b6bdf2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80",
      image:
        "https://images.unsplash.com/photo-1600984575359-310ae7b6bdf2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
    };
  },
  methods: {
    enter(e) {
      this.drag = true;
      e.preventDefault();
    },
    leave(e) {
      this.drag = false;
    },
    dropHandler(ev) {
      ev.preventDefault();
      let vm = this;
      if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (var i = 0; i < ev.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (ev.dataTransfer.items[i].kind === "file") {
            var file = ev.dataTransfer.items[i].getAsFile();
            this.showCropper = false;
            let imageFile = file;
            vm.uploading = true;
            vm.drag = false;
            vm.$nextTick(async () => {
              await vm.progressBar(imageFile);
              vm.$forceUpdate();
            });
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        for (var i = 0; i < ev.dataTransfer.files.length; i++) {
          this.showCropper = false;
          let imageFile = ev.dataTransfer.files[i];
          let vm = this;
          vm.uploading = true;
          vm.drag = false;
          vm.$nextTick(async () => {
            await vm.progressBar(imageFile);
            vm.$forceUpdate();
          });
        }
      }
    },
    dragOverHandler(e) {
      e.preventDefault();
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    doneCropping() {
      this.$emit("input", this.image);
      this.showCropper = false;
    },
    change({ coordinates, canvas }) {
      this.image = canvas.toDataURL();
    },
    resetProgressBar() {
      this.width = 1;
      clearInterval(this.interval);
      this.$refs.bar.style.width = this.width + "%";
    },
    async progressBar(imageFile) {
      this.resetProgressBar();
      this.$emit("reset");
      this.interval = await setInterval(this.frame, 10, imageFile);
    },
    frame(imageFile) {
      let vm = this;
      if (this.width >= 100) {
        clearInterval(this.interval);
        vm.uploading = false;
        vm.uploadSuccess = true;
        setTimeout(() => {
          var reader = new FileReader();

          reader.onload = function() {
            vm.img = reader.result;
            vm.showCropper = true;
            vm.uploadSuccess = false;
            vm.$forceUpdate();
          };

          reader.readAsDataURL(imageFile);
        }, 3000);
        vm.resetProgressBar();
        vm.$refs.file.value = "";
      } else {
        this.width++;
        this.$refs.bar.style.width = this.width + "%";
      }
    },
    onFileChange(e) {
      this.showCropper = false;
      let imageFile = e.target.files[0];
      let vm = this;
      vm.uploading = true;
      this.$nextTick(async () => {
        await vm.progressBar(imageFile);
        vm.$forceUpdate();
      });
    }
  }
};
</script>
<style lang="scss">
.uploading {
  .image-picker-placeholder-container {
    .image-placeholder {
      background: url("~@/assets/images/image-boundary.png");
      background-size: 100% 100%;
    }
  }
}
.upload-success {
  .image-picker-placeholder-container {
    .image-placeholder {
      background: url("~@/assets/images/image-boundary.png");
      background-size: 100% 100%;
    }
  }
}

.image-picker-placeholder-container {
  width: 501px;
  height: 331px;
  padding: 31px;
  border-radius: 20px;
  box-shadow: -1px 12px 23px rgb(0 0 0 / 11%) !important;
  h4 {
    font-family: Gotham-Medium;
    font-style: normal;
    font-weight: bold;
    font-size: 15.1604px;
    line-height: 18px;
    color: #000000;
  }
  @media all and (max-width: 960px) {
    width: 100%;
    height: 331px;
    .drop-image {
      width: 100%;
      height: 100%;
    }
  }
  .drop-image-placeholder {
    display: none;
  }
  .drop-image {
    display: block;
  }
  .progress-bar {
    background: #d7f4e4;
    width: 266px;
    .bar {
      background: #38c976;
      opacity: 1;
      height: 14px;
      width: 100%;
    }
  }
}
.image-placeholder {
  width: 100%;
  height: 100%;
  transition: 0.3s all;
}
.delete-btn {
  font-family: Gotham-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  border-radius: 20px !important;
}
</style>
